/**
 * Copyright 2026 OpenStack Foundation
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * */

import { LOGOUT_USER } from "openstack-uicore-foundation/lib/security/actions";
import {
  REQUEST_CURRENT_CART,
  RECEIVE_CURRENT_CART,
  CART_STATUS_UPDATED,
  PAYMENT_INTENT_CREATED,
  RECEIVE_PAYMENT_PROFILE,
  PAYMENT_INTENT_UPDATED,
  PAYMENT_CONFIRMED,
  OFFLINE_PAYMENT_CREATED,
  CART_PAYMENT_PRECONDITION_FAILED,
  REQUEST_PAYMENT_LOCK,
  PAYMENT_LOCK_RELEASED
} from "../actions/checkout-actions";
import { normalizeOrder } from "../utils/methods";

const DEFAULT_STATE = {
  currentCart: null,
  paymentProfile: null,
  paymentIntent: null,
  offlinePayment: null,
  paymentPreconditionFailed: false,
  paymentInProgress: false
};

const checkoutReducer = (state = DEFAULT_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT_USER:
      return DEFAULT_STATE;
    case REQUEST_CURRENT_CART:
      return {
        ...state,
        paymentProfile: null,
        paymentIntent: null,
        offlinePayment: null,
        // a fresh cart load means no payment of this page is in flight; clears a flag persisted by a closed tab
        paymentInProgress: false
      };
    case CART_STATUS_UPDATED:
    case RECEIVE_CURRENT_CART: {
      const data = payload.response;
      const currentCart = normalizeOrder(data);
      return { ...state, currentCart, paymentPreconditionFailed: false };
    }
    case RECEIVE_PAYMENT_PROFILE: {
      const paymentProfile = payload.response;
      return { ...state, paymentProfile };
    }
    case PAYMENT_INTENT_UPDATED:
    case PAYMENT_INTENT_CREATED: {
      const paymentIntent = payload.response;
      return { ...state, paymentIntent };
    }
    case PAYMENT_CONFIRMED: {
      return DEFAULT_STATE;
    }
    case CART_PAYMENT_PRECONDITION_FAILED: {
      return {
        ...state,
        paymentIntent: null,
        paymentProfile: null,
        paymentPreconditionFailed: true
      };
    }
    case REQUEST_PAYMENT_LOCK:
      return { ...state, paymentInProgress: true };
    case PAYMENT_LOCK_RELEASED:
      return { ...state, paymentInProgress: false };
    case OFFLINE_PAYMENT_CREATED: {
      const offlinePayment = payload.response;
      return { ...state, offlinePayment };
    }
    default:
      return state;
  }
};

export default checkoutReducer;
